import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../../constants/productTypes";
import { DealerVehicleResultsRoute } from "../../navigation/DealerRoutes";
import { useRouteParams } from "../../navigation/useRouteParams";
import { useGetNationalAccountInfoByNationalAccountUrlCode } from "../../queries/useGetNationalAccountInfoByNationalAccountUrlCode";
import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";

export const useSecondaryManufacturersProp = (): boolean => {
  const dealer = useNullableDealerAccountInfo();
  const params = useRouteParams(DealerVehicleResultsRoute);

  const { data: nationalAccountInfo } =
    useGetNationalAccountInfoByNationalAccountUrlCode();

  if (nationalAccountInfo) {
    switch (params?.productType) {
      case productTypeAccessory:
        return (
          nationalAccountInfo.nationalAccessoryShowSecondaryManufacturers ||
          false
        );
      case productTypePackage:
        return (
          nationalAccountInfo.nationalPackageShowSecondaryManufacturers || false
        );
      case productTypeWheel:
        return (
          nationalAccountInfo.nationalWheelShowSecondaryManufacturers || false
        );
      default:
        return (
          nationalAccountInfo.nationalTireShowSecondaryManufacturers || false
        );
    }
  }

  switch (params?.productType) {
    case productTypeAccessory:
      return dealer?.dealerAccessoryShowSecondaryManufacturers || false;
    case productTypePackage:
      return dealer?.dealerPackageShowSecondaryManufacturers || false;
    case productTypeWheel:
      return dealer?.dealerWheelShowSecondaryManufacturers || false;
    case productTypeTire:
      return dealer?.dealerTireShowSecondaryManufacturers || false;
    default:
      return [
        dealer?.dealerAccessoryShowSecondaryManufacturers,
        dealer?.dealerPackageShowSecondaryManufacturers,
        dealer?.dealerWheelShowSecondaryManufacturers,
        dealer?.dealerTireShowSecondaryManufacturers,
      ].some(Boolean);
  }
};
